import { DOCUMENT_LIBRARY } from '../../../utils/ServiceUtils';
import {ServiceBase} from '../ServiceBase';
import { ICreateDocumentInStorageRequest } from './requests/CreateDocumentInStorageRequest';
import { ICreateDocumentRequest } from './requests/CreateDocumentRequest';
import { IListDocumentCategoryRequest } from './requests/ListDocumentCategoryRequest';
import { IListDocumentLocationRequest } from './requests/ListDocumentLocationRequest';
import { IListDocumentRequest } from './requests/ListDocumentRequest';
import { IListDocumentTypeRequest } from './requests/ListDocumentTypeRequest';
import { IPermanentlyDeleteDocumentRequest } from './requests/PermanentlyDeleteDocumentRequest';
import { CreateDocumentResponse } from './responses/CreateDocumentResponse';
import { CreateDocumentInStorageResponse } from './responses/CreateDocumentInStorageResponse';
import { ListDocumentCategoryResponse } from './responses/ListDocumentCategoryResponse';
import { ListDocumentLocationResponse } from './responses/ListDocumentLocationResponse';
import { ListDocumentResponse } from './responses/ListDocumentResponse';
import { ListDocumentTypeResponse } from './responses/ListDocumentTypeResponse';
import { PermanentlyDeleteDocumentResponse } from './responses/PermanentlyDeleteDocumentResponse';
import { UpdateDocumentResponse } from './responses/UpdateDocumentResponse';
import { IUpdateDocumentRequest } from './requests/UpdateDocumentRequest';
import { ISaveDocumentRequest } from './requests/SaveDocumentRequest';
import { SaveDocumentResponse } from './responses/SaveDocumentResponse';

export interface IDocumentLibraryService {
    listDocument(request:IListDocumentRequest):Promise<ListDocumentResponse>;
    listDocumentType(request:IListDocumentTypeRequest):Promise<ListDocumentTypeResponse>;
    listDocumentCategory(request:IListDocumentCategoryRequest):Promise<ListDocumentCategoryResponse>;
    listDocumentLocation(request:IListDocumentLocationRequest):Promise<ListDocumentLocationResponse>;
    permanentlyDeleteDocument(request:IPermanentlyDeleteDocumentRequest):Promise<PermanentlyDeleteDocumentResponse>;
    createDocumentInStorage(request:ICreateDocumentInStorageRequest):Promise<CreateDocumentInStorageResponse>;
    createDocument(request:ICreateDocumentRequest):Promise<CreateDocumentResponse>;
    updateDocument(request:IUpdateDocumentRequest):Promise<UpdateDocumentResponse>;
    saveDocument(request:ISaveDocumentRequest):Promise<SaveDocumentResponse>;
}

export class DocumentLibraryService extends ServiceBase implements IDocumentLibraryService { 
    
    public async listDocument(request: IListDocumentRequest): Promise<ListDocumentResponse>{
        let response:any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.listDocument, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(DOCUMENT_LIBRARY.listDocument, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.listDocument, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['DOCUMENT']).ListDocumentResponse as ListDocumentResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listDocumentType(request: IListDocumentTypeRequest): Promise<ListDocumentTypeResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.listDocumentType, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.listDocumentType, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.listDocumentType, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['item']).ListDocumentTypeResponse as ListDocumentTypeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listDocumentCategory(request: IListDocumentCategoryRequest): Promise<ListDocumentCategoryResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.listDocumentCategory, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.listDocumentCategory, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.listDocumentCategory, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['item']).ListDocumentCategoryResponse as ListDocumentCategoryResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listDocumentLocation(request: IListDocumentLocationRequest): Promise<ListDocumentLocationResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.listDocumentLocation, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.listDocumentLocation, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.listDocumentLocation, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['item']).ListDocumentLocationResponse as ListDocumentLocationResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }
    
    public async permanentlyDeleteDocument(request: IPermanentlyDeleteDocumentRequest): Promise<PermanentlyDeleteDocumentResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.permanentlyDeleteDocument, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.permanentlyDeleteDocument, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.permanentlyDeleteDocument, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).PermanentlyDeleteDocumentResponse as PermanentlyDeleteDocumentResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createDocumentInStorage(request: ICreateDocumentInStorageRequest): Promise<CreateDocumentInStorageResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.createDocumentInStorage, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.createDocumentInStorage, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.createDocumentInStorage, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateDocumentInStorageResponse as CreateDocumentInStorageResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createDocument(request: ICreateDocumentRequest): Promise<CreateDocumentResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.createDocument, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.createDocument, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.createDocument, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateDocumentResponse as CreateDocumentResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateDocument(request: IUpdateDocumentRequest): Promise<UpdateDocumentResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.updateDocument, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.updateDocument, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.updateDocument, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateDocumentResponse as UpdateDocumentResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async saveDocument(request: ISaveDocumentRequest): Promise<SaveDocumentResponse>{
        let response:any = null;
        try {
            response = (await this.makeCall(request.toXml(), DOCUMENT_LIBRARY.saveDocument, request.cancelSource)).data ;
            await this.updateCache(DOCUMENT_LIBRARY.saveDocument, request.toXml(), response);
        } catch (error:any) {
            response = await this.getFromCache(DOCUMENT_LIBRARY.saveDocument, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).SaveDocumentResponse as SaveDocumentResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }
}